import styles from './ListViewHeader.module.scss'
import classNames from 'classnames'
import React from 'react'

export interface ListViewHeaderColumn {
  name: string
  label: string
  className?: string,
  hidden?: boolean
}

type Props = {
  columns: ListViewHeaderColumn[]
}

const ListViewHeader = (props: Props) => {
  const columns = props.columns.filter(column => !column.hidden)

  return (
    <div className={styles.component}>
      {columns.map((column, index) => (
        <div key={index} className={classNames(column.className)}>
          {column.label}
        </div>
      ))}
    </div>
  )
}

export default ListViewHeader